import { isBrowser } from '../utils/environment'
import { uniqueString } from '../utils/string'

const _handlers = uniqueString('BrowserErrorHandler_handlers')
const _onError = uniqueString('BrowserErrorHandler_onError')
const _listening = uniqueString('BrowserErrorHandler_listening')

export default class BrowserErrorHandler {
  constructor(onError) {
    if (!isBrowser() || typeof onError !== 'function') return
    if (!BrowserErrorHandler[_handlers]) {
      BrowserErrorHandler[_handlers] = new Set()
      BrowserErrorHandler[_listening] = false
    }

    this[_onError] = onError

    this.start()
  }

  start() {
    if (BrowserErrorHandler[_handlers].has(this)) return

    BrowserErrorHandler[_handlers].add(this)
    BrowserErrorHandler.start()
  }

  stop() {
    BrowserErrorHandler[_handlers].remove(this)

    if (!BrowserErrorHandler[_handlers].size) {
      BrowserErrorHandler.stop()
    }
  }

  static start() {
    if (BrowserErrorHandler[_listening]) return

    const onerror = window.onerror

    window.onerror = (...args) => {
      /* eslint-disable no-empty */
      try {
        if (typeof onerror === 'function') onerror(...args)
      } catch (error) {}
      /* eslint-enable no-empty */

      BrowserErrorHandler.handleError(...args)
    }

    BrowserErrorHandler[_listening] = true
  }

  static stop() {
    if (!BrowserErrorHandler[_listening]) return

    window.onerror = null

    BrowserErrorHandler[_listening] = false
  }

  static handleError(message, source, lineno, colno, error) {
    const errorLog = {
      message: message,
      source: source,
      lineno: lineno,
      colno: colno,
    }

    if (error && error.stack) {
      errorLog.stack = error.stack
    }

    /* eslint-disable no-empty */
    BrowserErrorHandler[_handlers].forEach((handler) => {
      try {
        handler[_onError](errorLog)
      } catch (error) {}
    })
    /* eslint-enable no-empty */
  }
}
